import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { dataURLtoFile } from '../utils/imageUtils'; // Adjust path

const useImageTransfer = (setFile, setPreviewUrl, setProcessedImage, onResetParams) => {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (location.state?.transferredImage) {
            const incomingImage = location.state.transferredImage;

            const processIncomingImage = async () => {
                try {
                    let convertedFile;
                    let displayUrl;

                    if (incomingImage.startsWith('http')) {
                        const response = await fetch(incomingImage, {
                            method: 'GET',
                            mode: 'cors',
                            cache: 'no-store',
                            credentials: 'omit'
                        });
                        if (!response.ok) throw new Error(`Fetch failed`);
                        const blob = await response.blob();
                        convertedFile = new File([blob], "transferred_image.png", { type: blob.type });
                        displayUrl = incomingImage; 
                    } else {
                        convertedFile = dataURLtoFile(incomingImage, "transferred_image.png");
                        displayUrl = incomingImage;
                    }

                    if (convertedFile) {
                        setFile(convertedFile);
                        setPreviewUrl(displayUrl);
                        setProcessedImage(null);
                        
                        // Run tool specific resets
                        if (onResetParams) onResetParams();

                        navigate(location.pathname, { replace: true, state: {} });
                    }
                } catch (err) {
                    console.error("Transfer error:", err);
                }
            };

            processIncomingImage();
        }
    }, [location, setFile, setPreviewUrl, setProcessedImage, onResetParams]);
};

export default useImageTransfer;
